{ "compressionlevel":-1,
 "height":30,
 "infinite":false,
 "layers":[
        {
         "data":[14, 13, 14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 14, 13, 14, 13, 14, 13,
            13, 14, 13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 13, 14, 13, 14, 13, 14,
            14, 13, 14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 13, 14, 13, 14, 13,
            13, 14, 13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 14, 13, 14, 13, 14,
            14, 13, 14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 12, 12, 12, 12, 13, 14, 13, 14, 13, 14, 13, 14, 13,
            13, 14, 13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 12, 12, 12, 12, 14, 13, 14, 13, 14, 13, 14, 13, 14,
            14, 13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 12, 12, 12, 12, 13, 14, 13, 14, 13, 14, 13, 14, 13,
            13, 14, 13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 12, 12, 12, 12, 14, 13, 14, 13, 14, 13, 14, 13, 14,
            14, 13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 12, 12, 12, 12, 13, 14, 13, 14, 13, 14, 13, 14, 13,
            13, 14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 14, 13, 14,
            14, 13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 14, 13,
            13, 14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 13, 14,
            14, 13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 14, 13,
            13, 14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 13, 14,
            14, 13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 14, 13,
            13, 14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 13, 14,
            14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 14, 13,
            13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 13, 14,
            14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 14, 13,
            13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 13, 14,
            14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 14, 13,
            13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 13, 14,
            14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 14, 13,
            13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 13, 14,
            14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 14, 13,
            13, 14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 13, 14,
            14, 13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 14, 13,
            13, 14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 13, 14,
            14, 13, 14, 13, 14, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 14, 13, 14, 13, 14, 13,
            13, 14, 13, 14, 13, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 14, 13, 14, 13, 14],
         "height":30,
         "id":1,
         "name":"tiles",
         "opacity":1,
         "type":"tilelayer",
         "visible":true,
         "width":30,
         "x":0,
         "y":0
        }, 
        {
         "data":[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 66, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 65, 0, 0, 65, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 66, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 65, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 66, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 65, 66, 0, 65, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 65, 66, 66, 65, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 65, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 65, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 66, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
         "height":30,
         "id":7,
         "name":"tiles",
         "opacity":1,
         "type":"tilelayer",
         "visible":true,
         "width":30,
         "x":0,
         "y":0
        }, 
        {
         "draworder":"topdown",
         "id":5,
         "name":"data:encounters",
         "objects":[
                {
                 "height":64,
                 "id":20,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"1"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":64,
                 "x":208,
                 "y":352
                }, 
                {
                 "height":64,
                 "id":21,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"3"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":64,
                 "x":208,
                 "y":192
                }, 
                {
                 "height":64,
                 "id":22,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"2"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":64,
                 "x":208,
                 "y":272
                }, 
                {
                 "height":112,
                 "id":23,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"4"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":64,
                 "x":208,
                 "y":64
                }],
         "opacity":1,
         "type":"objectgroup",
         "visible":true,
         "x":0,
         "y":0
        }, 
        {
         "draworder":"topdown",
         "id":6,
         "name":"data:spots",
         "objects":[
                {
                 "ellipse":true,
                 "height":16,
                 "id":24,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"spawn"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":16,
                 "x":224,
                 "y":400
                }, 
                {
                 "ellipse":true,
                 "height":16,
                 "id":25,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"spawn"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":16,
                 "x":240,
                 "y":400
                }, 
                {
                 "ellipse":true,
                 "height":16,
                 "id":26,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"spawn"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":16,
                 "x":256,
                 "y":400
                }, 
                {
                 "ellipse":true,
                 "height":16,
                 "id":27,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"spawn"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":16,
                 "x":208,
                 "y":400
                }, 
                {
                 "ellipse":true,
                 "height":16,
                 "id":28,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"spawn"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":16,
                 "x":224,
                 "y":320
                }, 
                {
                 "ellipse":true,
                 "height":16,
                 "id":29,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"spawn"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":16,
                 "x":240,
                 "y":320
                }, 
                {
                 "ellipse":true,
                 "height":16,
                 "id":30,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"spawn"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":16,
                 "x":256,
                 "y":320
                }, 
                {
                 "ellipse":true,
                 "height":16,
                 "id":31,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"spawn"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":16,
                 "x":208,
                 "y":320
                }, 
                {
                 "ellipse":true,
                 "height":16,
                 "id":32,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"spawn"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":16,
                 "x":224,
                 "y":240
                }, 
                {
                 "ellipse":true,
                 "height":16,
                 "id":33,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"spawn"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":16,
                 "x":240,
                 "y":240
                }, 
                {
                 "ellipse":true,
                 "height":16,
                 "id":34,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"spawn"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":16,
                 "x":256,
                 "y":240
                }, 
                {
                 "ellipse":true,
                 "height":16,
                 "id":35,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"spawn"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":16,
                 "x":208,
                 "y":240
                }, 
                {
                 "ellipse":true,
                 "height":16,
                 "id":40,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"spawn"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":16,
                 "x":224,
                 "y":160
                }, 
                {
                 "ellipse":true,
                 "height":16,
                 "id":41,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"spawn"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":16,
                 "x":240,
                 "y":160
                }, 
                {
                 "ellipse":true,
                 "height":16,
                 "id":42,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"spawn"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":16,
                 "x":256,
                 "y":160
                }, 
                {
                 "ellipse":true,
                 "height":16,
                 "id":43,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"spawn"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":16,
                 "x":208,
                 "y":160
                }, 
                {
                 "ellipse":true,
                 "height":16,
                 "id":44,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"monster2"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":16,
                 "x":240,
                 "y":272
                }, 
                {
                 "ellipse":true,
                 "height":16,
                 "id":45,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"monster3"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":16,
                 "x":224,
                 "y":192
                }, 
                {
                 "ellipse":true,
                 "height":16,
                 "id":46,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"monster4"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":16,
                 "x":240,
                 "y":112
                }],
         "opacity":1,
         "type":"objectgroup",
         "visible":false,
         "x":0,
         "y":0
        }],
 "nextlayerid":8,
 "nextobjectid":47,
 "orientation":"orthogonal",
 "renderorder":"right-down",
 "tiledversion":"1.8.6",
 "tileheight":16,
 "tilesets":[
        {
         "firstgid":1,
         "source":"..\/..\/..\/levels\/hero.tileset.json"
        }, 
        {
         "firstgid":1,
         "source":"..\/..\/..\/levels\/vmenezio.tileset.json"
        }],
 "tilewidth":16,
 "type":"map",
 "version":"1.8",
 "width":30
}